import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar28Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar28 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar28Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar28">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="Vector"
          d="M151.834 303.667c39.376 0 75.249-14.989 102.225-39.567-4.329-6.648-9.572-12.241-15.799-14.934-16.571-7.173-79.396-18.159-135.001-15.617-23.204 1.065-44.627 11.185-61.722 22.624 27.676 29.248 66.853 47.502 110.297 47.502v-.008Z"
          fill="#000"
        />
        <G id="Group">
          <Path
            id="skin"
            d="M224.986 161.953c2.137-11.701 1.168-14.036 1.168-29.105 1.827-40.854-3.043-78.475-43.277-78.475-72.644 0-79.912 19.494-79.912 65.138 0 2.375-.405 1.493-.191 3.948-6.887 0-12.837 14.687-9.818 23.83 7.07 21.432 26.778 20.757 27.111 20.574 2.749 6.315 5.044 52.245 0 57.25-5.044 5.004-20.224 9.214-20.224 9.214s12.67 43.38 52.65 42.141c28.025-1.653 42.029-31.584 37.946-38.82-1.731-3.075-10.477-2.542-6.164-28.971 7.395 1.947 12.241 5.315 20.026-1.914 4.52-6.403 15.736-31.123 20.685-44.818v.008Z"
            fill={c.skin}
          />
          <Path
            id="Vector_2"
            d="M141.825 120.003s12.662-3.892 22.512-3.828c11.574.079 19.7 7.657 21.925 3.781.706-1.232.23-7.714-20.86-9.842-9.437-.954-14.99 3.384-23.569 9.881l-.008.008Z"
            fill="#000"
          />
          <Path
            id="Vector_3"
            d="M183.004 136.494c-2.851-4.774-7.586-9.175-13.52-10.239-2.677-.31-5.385-.008-7.927.953-2.081.778-3.686 2.073-5.227 3.36-2.089 1.414-4.87.874-7.388.588 2.376 1.628 5.895 2.931 8.786 1.533.683-.437 1.358-.81 2.01-1.152-.016.207-.04.405-.04.62 0 3.797 3.249 6.871 7.268 6.871 4.02 0 7.269-3.074 7.269-6.871 0-.31-.032-.612-.072-.914 2.844 1.279 5.712 3.17 8.857 5.251h-.016Z"
            fill="#000"
          />
          <Path
            id="Vector_4"
            opacity={0.75}
            d="M204.539 122.299c-.27-.381-.27-1.009.079-1.756-9.921 13.933 3.782 36.35-1.564 40.584-3.734 2.955-17.85-1.176-18.398 2.606 5.14 3.177 19.295 5.711 23.577-1.637 1.676-3.789-9.421-29.01 1.581-39.813-2.082 1.454-4.361 1.295-5.283.016h.008Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_5"
            opacity={0.75}
            d="M169.651 176.919c.866.731 12.885 14.116 26.365 13.631 11.479-.413 15.188-11.423 15.466-11.987 0 0-5.076-4.75-8.595-4.623-3.527.127-5.989 1.835-5.989 1.835s-3.178-1.859-6.919-1.724c-3.749.135-7.086 2.05-10.589 2.622-3.543.579-9.731.246-9.731.246h-.008Zm4.854 2.137c-.095-.048-.008-.159.095-.119 4.29 1.509 11.741 2.533 23.275 2.12 5.942-.214 9.874-.405 13.131-1.461-3.241 1.311-7.515 4.837-13.449 5.052-11.566.421-18.81-3.36-23.052-5.592Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_6"
            d="M226.361 112.409c-13.83-.405-23.315 7.102-21.829 9.89.921 1.724 3.741 1.795 5.823-.151 5.711-4.79 10.136-3.193 16.117-3.273.135-1.978-.087-4.813-.119-6.466h.008Z"
            fill="#000"
          />
          <Path
            id="Vector_7"
            d="M231.762 131.227c-1.541-1.287-3.145-2.581-5.226-3.36-2.55-.969-5.251-1.263-7.928-.953-5.942 1.064-10.668 5.465-13.52 10.239 1.612-1.064 3.153-2.089 4.655-2.995.278 3.337 3.225 5.966 6.823 5.966 3.781 0 6.848-2.899 6.848-6.482 0-1.215-.374-2.343-.993-3.312 2.446.27 5.052 1.199 7.935 3.026 2.892 1.398 6.411.095 8.786-1.533-2.518.286-5.29.826-7.388-.588l.008-.008Z"
            fill="#000"
          />
          <Path
            id="hair"
            d="M129.465 122.911c2.144 6.744 2.756 16.546-1.835 17.158-4.6.611-11.947-21.138-26.039-12.257-14.092 8.889 13.893 40.671 18.484 40.059 1.16 3.472.652 1.541 1.128 4.695-2.669 1.048-19.001-2.169-19.31-6.156-.31-3.98-8.27-1.224-11.948-7.356-3.677-6.125-.62-8.166-.62-8.166s-7.228 1.017-9.92-4.361c-2.694-5.378 1.945-9.183 1.945-9.183s-12.796-1.39-13.813-8.627c-1.017-7.228 3.71-9.921 3.71-9.921s-7.23-4.361-7.515-10.851c-.278-6.49 5.934-10.104 5.934-10.104s-6.586-6.307-4.449-13.631c2.129-7.324 11.59-11.963 11.59-11.963s-2.884-5.53-.239-10.573c2.646-5.044 8.413-3.607 8.413-3.607S82.097 52.3 86.665 47.98c4.567-4.321 13.218-1.922 13.218-1.922s-2.645-8.166 4.567-12.496c7.205-4.32 14.418-.722 14.418-.722s3.606-6.49 8.651-7.69c5.044-1.2 8.888 2.645 8.888 2.645s5.767-7.45 13.933-7.45 11.773 7.204 11.773 7.204 4.567-6.966 15.617-5.767c11.049 1.2 12.733 10.088 12.733 10.088s8.166-5.528 15.141-2.16c6.966 3.36 6.728 13.218 6.728 13.218s9.612-2.16 13.456 2.883c3.845 5.044 1.923 13.846 1.923 13.846s7.967.921 9.953 7.356c1.994 6.434-3.217 13.94-3.217 13.94s6.895 3.678 5.211 10.725c-1.684 7.045-7.658 7.657-7.658 7.657s4.6 5.672.922 8.881c-3.678 3.217-7.507 3.829-7.507 3.829l-10.263-28.033s-4.44 1.533-7.046.15c-2.605-1.381-4.901-4.598-4.901-4.598s.921 2.907-5.362 2.756c-6.283-.151-10.112-4.6-10.112-4.6s-1.994 5.053-8.579 5.212c-6.585.15-13.79-4.902-13.79-4.902s0 6.586-3.678 9.342c-3.678 2.757-13.02-1.684-13.02-1.684l-6.585.763s4.599 12.868 1.382 19.152c-3.217 6.283-10.263 7.506-10.263 7.506s2.296 2.908.763 5.672c-1.533 2.756-4.496 4.099-4.496 4.099v.032Z"
            fill={c.hair}
          />
          <Path
            id="Vector_8"
            opacity={0.75}
            d="M147.068 209.035c13.925 11.931 27.358 15.752 36.334 16.697-1.2-7.554 1.477-16.38 1.104-16.555-27.183-13.13-59.759-34.713-64.287-41.385 0 .444 7.618 24.768 26.849 41.243Z"
            fill="#2E2017"
          />
        </G>
      </G>
    </Svg>
  );
};
